import { VStack, Text, SimpleGrid, GridItem, Link } from '@chakra-ui/react';
import { ProjectType } from '~/components/Layout/ProjectType';
import { format, parse } from 'date-fns';
import { join } from '~/utils';

export const ServiceRequestAddress = ({ row }: any) => {
    const { client = {}, branch = {} } = row?.original || {};
    return (
        <SimpleGrid columns={2} w="300px">
            <GridItem>Niederlassung:</GridItem>
            <GridItem>{`${branch.number} - ${branch.description}`}</GridItem>
            <GridItem>Auftraggeber:</GridItem>
            <GridItem>{client.name}</GridItem>
            <GridItem>Objekt:</GridItem>
            <GridItem>
                <VStack align="start" spacing={0}>
                    <Text>{client.address?.street}</Text>
                    <Text>{join([client.address?.postalCode, client.address?.city], ' ')}</Text>
                </VStack>
            </GridItem>
        </SimpleGrid>
    );
};

export const ServiceRequestTypes = ({ row }: any) => {
    const serviceTypes = row?.original?.details?.serviceTypes || {};
    return (
        <VStack align="start" spacing={1}>
            {serviceTypes.map((type: any) => (
                <ProjectType key={type}>{type}</ProjectType>
            ))}
        </VStack>
    );
};

export const ServiceRequestAttachments = ({ row }: any) => {
    const { attachments = [] } = row?.original || {};
    return (
        <VStack align="start" spacing={1}>
            {attachments.map(({ filename, url }: { filename: string; url: string }) => (
                <Link color="blue.500" key={filename} onClick={() => window.open(url)}>
                    {filename}
                </Link>
            ))}
        </VStack>
    );
};

export const ServiceRequestDateFormat = ({
    row,
}: {
    row: {
        original: {
            details: {
                receiptDateTime: { format: string; dateTime: string };
            };
        };
    };
}) => {
    const { receiptDateTime } = row?.original?.details || {};
    const date = parse(receiptDateTime.dateTime, receiptDateTime.format, new Date());
    const hasTime = receiptDateTime.format.includes('HHmm');
    const dateTime = hasTime ? format(date, 'dd.MM.yyyy, HH:mm') : format(date, 'dd.MM.yyyy');
    const width = hasTime ? 130 : 90;

    return (
        <VStack align="start" spacing={1}>
            <Text w={width}>{dateTime}</Text>{' '}
        </VStack>
    );
};
